// A screenshot of the restaurant's shop in the platform agent's panel (contracts §5 card shop_screenshot, §9).
export default {
  title: {
    phone: 'Twój sklep na telefonie',
    desktop: 'Twój sklep na komputerze',
  },
  loading: 'Wczytywanie zrzutu ekranu',
  failed: 'Nie udało się wczytać zrzutu ekranu.',
};
